import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=4124dca2&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=4124dca2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4124dca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4124dca2')) {
      api.createRecord('4124dca2', component.options)
    } else {
      api.reload('4124dca2', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=4124dca2&scoped=true", function () {
      api.rerender('4124dca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/layout/preview.vue"
export default component.exports